const { FLIGHT_REQUEST_OPTIONS } = require("@/config/constants");

export const initLegInfo = {
	from_airport: "",
	to_airport: "",
	departure_datetime: "",
	departure_window_datetime: "",
	passengers: 1,
};

export const initFormRequest = {
	type: FLIGHT_REQUEST_OPTIONS.ONE_WAY,
	legs: [initLegInfo],
	aircraft_categories: [],
	note: "",
	additional_info: {
		is_bring_pet: false,
		is_bring_oversize_luggage: false,
		is_interest_empty_leg: false,
	},
	requested_by: "",
};

export const initFormAirFreight = {
	from_airport: null,
	to_airport: null,
	note: "",
	company_name: "",
	contact: {
		name: "",
		email: "",
		phone: "",
	},
	cargo_info: {
		quantity: 0,
		weight_lb: 0,
		heigh_inch: 0,
		width_inch: 0,
		length_inch: 0,
	},
};

export const initFormAddAlertEmptyLegs = {
	from_airport: null,
	to_airport: null,
	type_airport: [], // DEPARTURE - ARRIVAL
	airport: null,
	type: "ROUTE", // ROUTE - AIRPORT
	from_datetime: null,
	to_datetime: null,
};
